import { render, staticRenderFns } from "./PaymentTransferDialog.vue?vue&type=template&id=7147008c&scoped=true&"
import script from "./PaymentTransferDialog.vue?vue&type=script&lang=js&"
export * from "./PaymentTransferDialog.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTransferDialog.vue?vue&type=style&index=0&id=7147008c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7147008c",
  null
  
)

export default component.exports